import type { TOC } from '@ember/component/template-only';
import SettingsRecommendationsCompetitorsImpact from 'lumen/components/settings/recommendations/competitors-impact';
import type HotelSettingsRecommendationsCompetitorsImpactRoute from 'lumen/routes/hotel/settings/recommendations/competitors-impact';
import type { ModelFrom } from 'lumen/utils/routes';

interface HotelSettingsRecommendationsCompetitorsImpactSignature {
  Args: {
    controller: unknown;
    model: ModelFrom<HotelSettingsRecommendationsCompetitorsImpactRoute>;
  };
}

<template>
  <SettingsRecommendationsCompetitorsImpact @model={{@model}} />
</template> satisfies TOC<HotelSettingsRecommendationsCompetitorsImpactSignature>;
